import { Injectable } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';

import { I18nService } from '../i18n/i18n.service';
import { isNullOrUndefined } from '../utils/js-utils';

@Injectable({
  providedIn: 'root',
})
export class InteractionService {
  constructor(
    private alertCtrl: AlertController,
    private i18n: I18nService,
    private toastCtrl: ToastController,
  ) {}

  async showToaster(input: ToastInput) {
    input = { ...TOAST_DEFAULTS, ...input };
    const toast = await this.toastCtrl.create({
      message: input.message,
      duration: input.duration,
      color: input.color,
      icon: input.icon,
      mode: 'ios',
    });
    await toast.present();
  }

  async showAlertRadios<T>(header: string, message: string, choices: AlertRadioChoice<T>[]): Promise<T | null> {
    const alert = await this.alertCtrl.create({
      header,
      message,
      buttons: [
        { text: this.i18n.translate('INTERACTION_SERVICE.SHOW_ALERT_BUTTON.CANCEL'), role: 'cancel' },
        { text: this.i18n.translate('INTERACTION_SERVICE.SHOW_ALERT_BUTTON.OK'), role: 'confirm' },
      ],
      inputs: choices.map((x) => ({ label: x.label, type: 'radio', value: x.value, checked: x.checked })),
    });

    await alert.present();
    const result = await alert.onDidDismiss();

    if (result.role !== 'confirm' || isNullOrUndefined(result.data?.values)) return null;

    return result.data.values as T;
  }
}

export interface ToastInput {
  message: string;
  color?: 'primary' | 'secondary' | 'danger' | 'warning' | 'success';
  duration?: number;
  icon?: string;
}

const TOAST_DEFAULTS: Partial<ToastInput> = {
  duration: 3000,
  color: 'primary',
};

export interface AlertRadioChoice<T> {
  label: string;
  value: T;
  checked?: boolean;
}
